
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M10.367 17.74l-.063.06c-.981 1.004-2.117 1.534-3.287 1.534-2.444 0-4.217-1.84-4.217-4.377 0-2.534 1.773-4.377 4.217-4.377 1.17 0 2.306.534 3.287 1.541l.063.06 1.571-1.907-.042-.051c-1.307-1.55-2.875-2.304-4.803-2.304-1.933 0-3.703.654-4.976 1.831C.73 11.026 0 12.826 0 14.957c0 2.13.73 3.934 2.117 5.21C3.39 21.351 5.16 22 7.093 22c1.928 0 3.496-.755 4.803-2.305l.042-.047-1.571-1.909m3.159 4.001H16.3V8.14h-2.775v13.6m13.652-2.957c-.742.453-1.43.681-2.05.681-.897 0-1.304-.476-1.304-1.534v-7.217h2.83v-2.56h-2.83V3.92l-2.72 1.463v2.77h-2.348v2.56h2.348v7.676c0 2.09 1.235 3.522 3.079 3.56 1.251.024 2.005-.35 2.462-.625l.03-.019.667-2.623-.164.101m2.297 2.957h2.78V8.14h-2.78v13.6","fill":"#004685"}}),_c('path',{attrs:{"d":"M33.873 5.755C31.337 2.15 27.125 0 22.84 0c-4.284 0-8.496 2.15-11.028 5.755l-.13.186h3.193l.035-.039c2.173-2.252 5.012-3.442 7.93-3.442 2.919 0 5.755 1.19 7.933 3.442l.035.039H34l-.127-.186","fill":"#EE1C25"}})])])
          )
        }
      }
    